var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper"},[(_vm.title)?_c('div',{staticClass:"page-header-wrapper"},[_c('h1',{staticClass:"page-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._t("actions")],2):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }